import React, { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errMsg } from "@/components/email/EmParts";

const LABELS = { email: "Email *", first_name: "First name", last_name: "Last name", status: "Status", subscribed_at: "Subscribed at", unsubscribed_at: "Unsubscribed at",
  created_at: "Created at", tags: "Tags", list: "List name column", reason: "Suppression reason", evidence: "Consent evidence / source", ip: "IP address", extra_attributes: "Extra attributes" };

export const MailcoachFileCard = ({ batchId, file, editable, onChange }) => {
  const [m, setM] = useState(file.mapping);
  const [kind, setKind] = useState(file.kind);
  const [listName, setListName] = useState(file.list_name || "");
  const save = async () => {
    try { await api.put(`/email-marketing/mailcoach/batches/${batchId}/files/${file.id}`, { mapping: m, kind, list_name: listName }); toast.success("Mapping saved. Run the dry run again"); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async () => { try { await api.delete(`/email-marketing/mailcoach/batches/${batchId}/files/${file.id}`); onChange(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="border border-slate-200 rounded-xl p-3 space-y-2" data-testid={`mc-file-${file.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <b className="text-sm text-slate-800 break-all">{file.filename}</b><span className="text-xs text-slate-500">{file.row_count.toLocaleString()} rows</span>
        <select className="text-xs border rounded-md px-1.5 py-1" value={kind} disabled={!editable} onChange={(e) => setKind(e.target.value)} data-testid={`mc-file-kind-${file.id}`}>
          <option value="subscribers">Subscriber list export</option><option value="suppressions">Suppression list export</option>
        </select>
        {editable && <button type="button" className="ml-auto text-rose-600" onClick={remove} data-testid={`mc-file-remove-${file.id}`}><Trash2 className="w-4 h-4" /></button>}
      </div>
      {kind === "subscribers" && <Input className="h-8 text-xs" value={listName} disabled={!editable} onChange={(e) => setListName(e.target.value)} placeholder="TedOps list name for this file" data-testid={`mc-file-list-${file.id}`} />}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">{Object.keys(LABELS).map((k) => (
        <label key={k} className="text-[11px] text-slate-500">{LABELS[k]}
          <select className="block w-full text-xs border rounded-md px-1 py-1 mt-0.5 text-slate-800" value={m[k] || ""} disabled={!editable} onChange={(e) => setM({ ...m, [k]: e.target.value })} data-testid={`mc-map-${k}-${file.id}`}>
            <option value="">(not mapped)</option>{file.headers.map((h) => <option key={h} value={h}>{h}</option>)}
          </select></label>))}</div>
      {editable && <Button size="sm" variant="outline" onClick={save} data-testid={`mc-file-save-${file.id}`}>Save mapping</Button>}
    </div>
  );
};
